import { usePutFrontRichiesteIdComunicazioniIdSegnaLetta } from '@framework/api-client/api/inquiries-compile/comunicazioni-inalterate/comunicazioni-inalterate.ts';
import { getGetFrontRichiesteV2IdComunicazioniQueryKey } from '@framework/api-client/api/inquiries-compile/comunicazioni-v2/comunicazioni-v2.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { queryClient } from '../../../../core/network/queryClient.ts';

interface IProps {
  submissionId: string | null | undefined;
}

/**
 * Presa lettura di una comunicazione ricevuta lato frontoffice: invalida
 * per prefisso tutte le varianti della lista comunicazioni della richiesta
 * (compresa la query del badge non lette, che usa lo stesso endpoint)
 * senza resettare filtri o paginazione.
 */
export function useCommunicationMarkAsRead(props: IProps) {
  const { submissionId } = props;
  const { t } = useTranslation();

  const mutation = usePutFrontRichiesteIdComunicazioniIdSegnaLetta();
  const { mutateAsync } = mutation;

  return useCallback(
    async (communicationId: string) => {
      if (!submissionId) {
        message.error(
          t(
            'submission-sent-tab-communications.errore-segna-letta-no-id',
            'Errore durante la presa lettura: Nessun ID trovato per la richiesta.',
          ),
        );
        return;
      }
      try {
        await mutateAsync({
          idRichiesta: submissionId,
          idComunicazione: communicationId,
        });
        // Chiave parziale (senza parametri): invalida per prefisso ogni
        // variante della lista, inclusa quella del badge non lette
        await queryClient.invalidateQueries(
          getGetFrontRichiesteV2IdComunicazioniQueryKey(submissionId),
        );
      } catch (e) {
        console.error(e);
        message.error(
          getNetworkErrorMessage(
            e,
            t(
              'submission-sent-tab-communications.errore-segna-letta',
              'Impossibile segnare la comunicazione come letta',
            ),
          ),
        );
      }
    },
    [mutateAsync, submissionId, t],
  );
}
